// extracted by mini-css-extract-plugin
export default {"priceRadioGroup":"AddForm_priceRadioGroup__i-xSd"};